<template>
	<template v-if="!isComplete">
		Загружается...
	</template>
	<template v-else>
		<template v-if="!found">
			<button-component  type="button" class="btn btn-primary mx-2 width-auto" v-on:click="createRoute">Создать</button-component>
		</template>
		<template v-else>
			<div class="form-group  d-flex flex-wrap align-items-center solid justify-content-between mt-3">
				<h4 
					:class="{'marker-new': checkModifiedItem(currentRoute?.id,1)}"
					class="m-0">
					{{currentRoute?.name}}
				</h4>
				<div class="d-flex flex-wrap" v-if="currentRoute?.name?.includes('Новый маршрут')">
					<button-component class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto" 
					v-on:click="saveRoute" v-if="!isReadonly && isCompleteAdd" :disabled="isSaving"><i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"> </i>Сохранить</button-component>
				</div>
			</div>
			<div class="table-inner mb-4">
				<table class="table-custom" v-if="currentRoute.stepsDto && currentRoute.stepsDto.length > 0">

					<thead>
					<tr>
						<th width="150px" class="align-middle text-center">Этап</th>
						<th width="420px" class="align-middle ">Организация</th>
						<th width="150px" class="align-middle">Дата поступления</th>
						<th width="150px" class="align-middle">Дата смены статуса</th>
						<th class="align-middle">Ответственный</th>
						<th width="150px" class="align-middle">Статус, комментарий</th>
						<th width="150px" class="align-middle">Действия</th>
					</tr>
					</thead>

					<tbody>
						<tr v-for="(step, stepIdx) in currentRoute.stepsDto" :key="step.id">
							<td class="align-middle  text-center">
								<div>{{ stepIdx===0 ? 'Формирование' : (stepIdx===1 ? 'Согласование' : 'Утверждение') }}</div>
								<button class="btn" :disabled="step.isComplete" title="Добавить подписанта" @click="addSigner(step)" v-if="!isReadonly && stepIdx === 1"><i
									class="fa fa-plus"></i></button>	
							</td>
							<td class="p-0" v-if="step.isComplete">
								<div class="signer-item" v-for="(signer) in step.signersDto" :key="signer.id">
									{{ signer.organization?.nameFull }}
								</div>
							</td>
							<td class="p-0" v-else>
								<div class="signer-item select2"  v-for="(signer) in step.signersDto" :key="signer.id">
									<Select2
										:options="stepIdx === 0 ? organizationsEdit : (stepIdx === 1 ? organizationsApprove : organizationsFinish)"
										v-model="signer.organizationId"
										required="required"
										style="width: 100%"
										class="select2"
										v-if="!signer.userId" />
									<div v-else>{{ signer.organization?.nameFull }}</div>
									<div class="invalid-msg d-block" v-if="!signer.organizationId">Введите данные</div>
								</div>
							</td>					
							<td class="p-0">
								<div  class="signer-item" v-for="(signer) in step.signersDto" :key="signer.id">
									{{ stepIdx > 0 ? $momentFormat(currentRoute.stepsDto[stepIdx - 1].dtComplete, "DD.MM.YYYY HH:mm") : '' }}
								</div>
							</td>
							<td class="p-0">
								<div  class="signer-item" v-for="(signer) in step.signersDto" :key="signer.id">
									{{ $momentFormat(signer.dtComplete, "DD.MM.YYYY HH:mm") }}{{signer.userId && !signer.decision ? 'Причина отклонения: ' + signer.comment : ''}}
								</div>
							</td>

							<td class="p-0">
										<div class="signer-item" v-for="(signer) in step.signersDto" :key="signer.id">
											<div>{{ signer.userText }}</div>
										</div>								
							</td>
							<td class="p-0">
										<div class="signer-item" v-for="(signer) in step.signersDto" :key="signer.id">
											<div :class="signer.decision ? 'text-success' : ''" v-if="signer.decision">{{signerDecision(signer, stepIdx)}}</div>	
										</div>								
							</td>							

							<td v-if="stepIdx===0"><div class="signer-item"/></td>
							<td v-else class="p-0" >
								<div class="signer-item" v-for="(signer, signerIdx) in step.signersDto" :key="signer.id">
									<button class="btn" :title="stepIdx===2 ? 'Утвердить' : 'Согласовать'" v-if="signer.acceptAvailable && canApproveImar"><i class="fas fa-check text-success" v-on:click="accept(signer.id, stepIdx)"/>
									</button>
									<button class="btn" title='Отказать' v-if="signer.rejectAvailable"><i class="fas fa-times text-danger" v-on:click="reject(signer.id)"/>
									</button>
									<button class="btn" title='Отозвать решение' v-if="signer.undoAvailable"><i class="fas fa-undo" v-on:click="undo(signer.id)"/>
									</button>
									<button v-if="stepIdx === 1 && !isReadonly && !signer.userId && step.signersDto.length > 1" class="btn" title="Удалить подписанта"
											v-on:click="deleteSigner(stepIdx, signerIdx)"><i class="fa fa-trash"></i></button>							
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>		 
			<section class="modals">
				<modal-component v-if="modals.reject.show" title="Введите комментарий" size-class="" @close="modals.reject.show = false">
					<reject-with-comment
							:signer-id="modals.reject.signerId" :route-id="modals.reject.routeId"
							@close="modals.reject.show = false"
							@save="modals.reject.show = false; updateHistoryTrigger++; $emit('reload');"/>
				</modal-component>
				<modal-component v-if="modals.finish.show" title="Заполните данные ИМАР" size-class="" @close="modals.finish.show = false">
					<finish-route-data
							:journal-id="journalId"
							:num="modals.finish.numImar"
							:date="modals.finish.dateImar"
							@close="modals.finish.show = false"
							@filldata="onFillData"/>
				</modal-component>				
			</section>
		</template>
		<HistoryRouteComponent
			:responseStatusOfChange="responseStatusOfChange" 
			:journalId="journalId" 
			:needUpdate="updateHistoryTrigger"
		/> 		
	</template>
</template>

<script>
import API from "../api/route";
import APIjournal from '../api/journal';
import Constants from '@/common/constants';
import ModalComponent from "@/common/ui/ModalComponent";
import RejectWithComment from "../components/RejectWithComment";
import FinishRouteData from "../components/FinishRouteData";
import ButtonComponent from "@/common/ui/ButtonComponent";
import HistoryRouteComponent from '../components/HistoryRouteComponent.vue';
import security from "@/common/mixins/security";

export default {
	name: "PassingRouteComponent",
	components: {
		ModalComponent,
		RejectWithComment,
		ButtonComponent,
		HistoryRouteComponent,
		FinishRouteData
	},
  mixins: [security],
    watch: {
        journalId: function (/*newValue, oldValue*/) {
            this.loadCurrentRoute();
        }
    },  
	props: {
		journalId: {
			type: Number,
			required: true,
			default: 0
		},
		isReadonly: {
			type: Boolean,
			default: false
		},
		responseStatusOfChange: Array
	},
	data() {
		return {
			isComplete: false,
			isCompleteAdd: true,
			isLoadCreate: false,
			isSaving: false,
			currentRoute: {},
			modals: {
				reject: {
					show: false,
					signerId: null,
					routeId: null
				},
				finish: {
					show: false,
					signerId: null,
					numImar: null,
					dateImar: null
				}				
			},
			organizationsEdit: [],
			organizationsFinish: [],
			organizationsApprove: [],
			canApproveImar: true,
			nextSignerId: -1,
			updateHistoryTrigger: 0
		};
	},
	computed: {
		found() {
			return (this.currentRoute != null && this.currentRoute != undefined)
		}
	},
	created() {
		this.loadCurrentRoute()
		this.loadDictionaries()
		this.getAccessMatrix([Constants.JournalImarApprove, Constants.JournalRouteView, Constants.JournalRouteEdit])
			.then((response) => {
				this.canApproveImar = response.data[Constants.JournalImarApprove] &&
					(response.data[Constants.JournalRouteView] || response.data[Constants.JournalRouteEdit]);
		});
	},
	emits: ['reload', 'reloadSimple'],
	methods: {
		loadCurrentRoute() {
			if (this.journalId > 0) {
				var self = this;
				API.current({journalId: this.journalId}).then(function (response) {
					self.currentRoute = response.data;
					if (self.currentRoute) {
						self.currentRoute.stepsDto = self.currentRoute.stepsDto.sort(function (a, b) {
							return a.orderNum - b.orderNum
						});
						self.currentRoute.stepsDto.forEach(st => {
							st.signersDto = st.signersDto.sort(function (a, b) {
								return a.id - b.id
							});
						});
					}
					self.isComplete = true;
				});
			} else {
				this.isComplete = true;
			}			
		},
		loadDictionaries() {
			API.loadOrganizationList('edit')
				.then((response) => {
					this.organizationsEdit = response.data;
				});
			API.loadOrganizationList('finish')
				.then((response) => {
					this.organizationsFinish = response.data;
				});
			API.loadOrganizationList('approve')
				.then((response) => {
					this.organizationsApprove= response.data;
				});								
		},
		signerDecision(signer, stepIdx) {
			var positive = 'Согласован';
			if (stepIdx === 0)
			positive = 'Создан';
			if (stepIdx === 2)
			positive = 'Утвержден';
			return signer.decision ? positive : (signer.decision === false ? 'Отказ' : 'Решение не выносилось')
		},		
		onFillData(data) {
			this.modals.finish.show = false; 
			this.modals.finish.numImar = data.numImar;
			this.modals.finish.dateImar = data.dateImar;
			this.acceptStep(this.modals.finish.signerId, data.numImar, data.dateImar)
		},	
		reject(signerId) {
			this.modals.reject = {
				show: true,
				signerId: signerId,
				routeId: this.currentRoute.id
			};
		},
		accept(signerId, stepIdx) {
			if (stepIdx === 2) {
				this.modals.finish = {
					show: true,
					signerId: signerId,
				}
			} else {
				this.acceptStep(signerId)
			}
		},		
		acceptStep(signerId, numImar, dateImar) {
			var self = this;
			var isLastStep = numImar && dateImar ? true : false;
			var modalTitle = isLastStep ? 'Утверждение ИМАР' : 'Согласование ИМАР';
			
			var options = {
				title: modalTitle,
				text: isLastStep ? 'Вы действительно хотите утвердить ИМАР' : 'Вы действительно хотите согласовать ИМАР',
				confirmButtonText: isLastStep ? 'Утвердить' : 'Согласовать',
				cancelButtonText: 'Отмена',
				showCancelButton: true,
				icon: 'warning',
			};
			Constants.alert.fire(options).then((res) => {
				if (res.isConfirmed) {
					API.confirmStep(signerId, numImar, dateImar).then(function (response) {
						if(response.data.success) {
							var options2 = {
								title: modalTitle,
								text: isLastStep ? 'Утверждено' : 'Согласовано',
								icon: 'success'
							};
							// Constants.alert.fire(isLastStep ? 'Утверждение ИМАР' : 'Согласование ИМАР', 
							// 	isLastStep ? 'Утверждено' : 'Согласовано', 
							// 	response.data.success ? 'success' : 'error');
							Constants.alert.fire(options2).then(() => {
								if (isLastStep) {
									self.$emit('reload');
								}
							});
							self.loadCurrentRoute();
							if (isLastStep) {
								self.updateHistoryTrigger++
								//self.$emit('reload');//вынесено только после закрытия окошка модального
							} else {
								self.$emit('reloadSimple');
							}
						} else {
							Constants.alert.fire(modalTitle, 
								response.data.message ? response.data.message : 'Произошла ошибка', 
								'error');
							self.modals.finish.show = true;
						}						
					})
				}
			});
		},
		undo(signerId) {
			var self = this;
			var options = {
				title: 'Подтверждение',
				text: 'Вы действительно отозвать свое решение',
				confirmButtonText: 'Подвердить',
				cancelButtonText: 'Отмена',
				showCancelButton: true,
				icon: 'warning',
			};
			Constants.alert.fire(options).then((res) => {
				if (res.isConfirmed) {
					API.undoStep(signerId).then(function (response) {
						Constants.alert.fire('Отзыв решения', response.data.message, response.data.success ? 'success' : 'error');
						//self.loadCurrentRoute();
						self.$emit('reload');
					})
				}
			});
		},
		deleteSigner(stepIdx, signerIdx) {
			this.currentRoute.stepsDto[stepIdx].signersDto.splice(signerIdx, 1);
		},		
		addSigner(step) {
			var newSigner = {id: 0, routeStepId: step.id, journalRouteStepId: step.id, innerId: this.nextSignerId};
			this.nextSignerId--;
			step.signersDto.push(newSigner);
		},
		createRoute() {
			this.isCompleteAdd = false;
			this.currentRoute = {id: 0, steps: [],stepsDto: [], journalId: this.journalId, isActive: true, isComplete: false, name: 'Новый маршрут абилитации и реабилитации'}
			API.find(1).then(response=>{
				var stepsInternal = [];
				response.data.steps.forEach(st => {
				const stInternal = Object.assign({}, st);
				stInternal.id = 0;
				stInternal.journalRouteId = this.currentRoute.id;
				stInternal.signers=[];
				stInternal.signersDto=[];
				st.signers.forEach(s=>{
					const sInternal = Object.assign({}, s);
					sInternal.id = 0;
					sInternal.journalRouteStepId = 0;
					stInternal.signers.push(sInternal);
					stInternal.signersDto.push(sInternal);
				});
				stepsInternal.push(stInternal);
				});
				this.currentRoute.stepsDto = stepsInternal;
				this.isCompleteAdd = true;
				console.log(this.currentRoute, '----------- созлали новый маршрут')
			})			
		//var step = {id: 0, orderNum: 1, journalRouteId: 0, isComplete: false, isActive: true, signers: []}
		//this.currentRoute.steps.push(step);
		},			
		saveRoute() {
			this.isSaving = true;

			var isValid = true;
			this.currentRoute.stepsDto.forEach(function(el){
				el.signersDto.forEach(function(s){
				if(!(s.organizationId))
					isValid = false;
				});
			});
			if (!isValid) {
				Constants.alert.fire('Ошибка', 'Необходимо корректно заполнить Организации и для всех этапов', 'error');
				this.isSaving = false;
				return;
			}

			const journalRoute = Object.assign({}, this.currentRoute);
			journalRoute.steps = this.currentRoute.stepsDto;
			journalRoute.steps.forEach((s)=>{s.signers = s.signersDto});

			APIjournal.saveRoute(journalRoute).then((response) => {
				if (journalRoute.id === 0 && response.data.success) {
					Constants.alert.fire('Успешно', 'Маршрутный лист успешно сохранен, теперь доступно формирование ИМАР', 'success')
						.then(() => {
							this.$emit('reload');
						});
				} else {
					if (response.data.success) {
						Constants.alert.fire('Успешно', 'Маршрутный лист успешно сохранен', 'success')
							.then(() => {
							this.$emit('reload');
							});
					}
					else
						Constants.alert.fire('Ошибка', response.data.message, 'error');
				}
			})
			.finally(() => {
				this.isSaving = false;
			});     
		},
		checkModifiedItem(id, statusId) {
			let check = false;
			let patientChangeId = statusId;
			if(this.responseStatusOfChange){
				this.responseStatusOfChange.findIndex(element => {
					if (element.itemId === id && element.patientChangeId === patientChangeId) {
						check = true;
						return check;
					}
					check = false;
					return check;
				});
				return check
			}
		}			
	}
}
</script>


<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-check {
	padding: 0;
}
.table-custom{
	tr{
		td{
			padding: 20px 16px;
			vertical-align: top;
		}
	}
}
.signer-item{
	padding: 10px 10px;
	max-height: 150px;
	&:not(:last-child){
		border-bottom: 1px solid #d7d7e0
	};
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	overflow: hidden;
}
tr.noBorder td {
	border: 0;
	width: 100%
}

.form-check-input {
	position: static !important;
}

.solid {
    background-color:#F5F5FA;//rgba(171,171,179, 0.1);
    line-height: 3rem;
    letter-spacing: 0.5px;
}

.table-custom tr td {
	vertical-align: middle;
}
</style>
